"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import { RetroGrid } from "@/components/ui/retro-grid";

interface LoadingOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  loading?: boolean;
  children: React.ReactNode;
}

export const LoadingOverlay = React.forwardRef<
  HTMLDivElement,
  LoadingOverlayProps
>(({ className, loading = false, children, ...props }, ref) => {
  return (
    <div className="relative h-full" ref={ref} {...(props as any)}>
      {children}
      {loading && (
        <div
          className={cn(
            "absolute inset-0 z-50 flex items-center justify-center",
            "bg-background",
            "max-h-screen",
            loading && "overflow-y-scroll overscroll-contain",
            className,
          )}
        >
          <div className="flex flex-col gap-2 align-center">
            <span className="pointer-events-none z-10 bg-linear-to-b from-[#ffd319] via-[#ff2975] to-[#8c1eff] bg-clip-text text-center text-7xl leading-none font-bold tracking-tighter whitespace-pre-wrap text-transparent">
              Loading...
            </span>
          </div>
          <RetroGrid />
          <div className="flex flex-col items-center gap-2"></div>
        </div>
      )}
    </div>
  );
});

LoadingOverlay.displayName = "LoadingOverlay";
